import { render } from "./AllRmaPurchasing.vue?vue&type=template&id=663bbccb"
import script from "./AllRmaPurchasing.vue?vue&type=script&lang=js"
export * from "./AllRmaPurchasing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__